import React, { useMemo } from "react";
import { useTheme } from "@/contexts/theme";

const rgbToString = ([r, g, b]: RgbColor) =>
  `${r.toString()},${g.toString()},${b.toString()}`;

const rgbToP3String = ([r, g, b]: RgbColor) =>
  `${(r / 255).toFixed(6)} ${(g / 255).toFixed(6)} ${(b / 255).toFixed(6)}`;

const Themes: React.FC = () => {
  const { theme } = useTheme();

  const colors = useMemo<
    | {
        primary: string;
        background: string;
        foreground: string;
      }
    | undefined
  >(() => {
    switch (theme) {
      case "red":
        return {
          primary: "red",
          background: "red",
          foreground: "mirage",
        };
      case "mirage":
        return {
          primary: "confetti",
          background: "confetti",
          foreground: "mirage",
        };
      case "ice":
        return {
          primary: "ice",
          background: "ice",
          foreground: "mirage",
        };
      case "dark":
        return {
          primary: "ice",
          background: "dark",
          foreground: "ice",
        };
      default:
        return {
          primary: "confetti",
          background: "mirage",
          foreground: "confetti",
        };
    }
  }, [theme]);

  if (typeof theme === "object") {
    return (
      <style>
        {`
          :root {
            --color-primary: ${rgbToString(theme.primary)};
            --color-primary-p3: ${rgbToP3String(theme.primary)};
            --color-front:${rgbToString(theme.foreground)};
            --color-front-p3: ${rgbToP3String(theme.foreground)};
            --color-back: ${rgbToString(theme.background)};
            --color-back-p3: ${rgbToP3String(theme.background)};
            --color-back-near: ${rgbToString(theme.backgroundNear)};
            --color-back-near-p3: ${rgbToP3String(theme.backgroundNear)};
          }
        `}
      </style>
    );
  }

  if (!colors) return null;

  return (
    <style>
      {`
        :root {
          --color-primary: var(--color-${colors.primary});
          --color-primary-p3: var(--color-${colors.primary}-p3);
          --color-front: var(--color-${colors.foreground});
          --color-front-p3: var(--color-${colors.foreground}-p3);
          --color-back: var(--color-${colors.background});
          --color-back-p3: var(--color-${colors.background}-p3);
          --color-back-near: var(--color-${colors.background}-near);
          --color-back-near-p3: var(--color-${colors.background}-near-p3);
        }
      `}
    </style>
  );
};

export default Themes;
